"use client";

import { useEffect } from "react";

/** Tells the site, once, that this post or page was opened, so the blog can show how often it is read. Sends only what was opened (no person, no cookie) and ignores failures. */
export function ViewBeacon({ kind, id, locale }: { kind: "post" | "page"; id: string; locale: string }) {
  useEffect(() => {
    void fetch("/api/blog/view", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ kind, id, locale }), keepalive: true }).catch(() => null);
  }, [kind, id, locale]);
  return null;
}
